import React from "react";
import { X } from "lucide-react"; // Optional: icon package, install with `npm i lucide-react`

export default function Paymentmode({
  isOpen,
  onClose,
  onSelect,
  setPaymenttype,
  isLoggingIn,
  paymenttype,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg w-full max-w-md shadow-lg overflow-hidden">
        {/* Header */}
        <div className="bg-[#0c4079] px-5 py-4 flex justify-between items-center">
          <h2 className="text-white font-semibold text-lg">Select Payment</h2>
          <button onClick={onClose}>
            <X className="text-white w-5 h-5" />
          </button>
        </div>

        {/* Options */}
        <div className="px-5 py-6 space-y-3">
          <button
            onClick={() => setPaymenttype("SKIP")}
            className={`w-full px-4 py-3 rounded-md flex justify-between items-center text-sm
              ${
                paymenttype === "SKIP"
                  ? "border-2 border-[#0c407980] bg-[#eaf3fc] text-[#0c4079]"
                  : "border-2 border-gray-300 bg-[#f5faff] text-[#0c4079]"
              }`}
          >
            Pay During Visit
            <span className="text-[#0c4079]">&gt;</span>
          </button>
          <button
            onClick={() => setPaymenttype("PAY")}
            className={`w-full px-4 py-3 rounded-md flex justify-between items-center text-sm
              ${
                paymenttype === "PAY"
                  ? "border-2 border-[#0c407980] bg-[#eaf3fc] text-[#0c4079]"
                  : "border-2 border-gray-300 bg-[#f5faff] text-[#0c4079]"
              }`}
          >
            Pay Now
            <span className="text-[#0c4079]">&gt;</span>
          </button>
        </div>

        {/* Pay Button */}
        <div className="px-5 pb-6">
          <button
            onClick={onSelect}
            className="w-full bg-[#3cba84] hover:bg-[#35a874] text-white py-2 rounded-md font-medium"
          >
            {isLoggingIn ? "Loading.." : "Proceed"}
          </button>
        </div>
      </div>
    </div>
  );
}
